import React from 'react';
import PropTypes from 'prop-types';

const Input = ({ 
  label, 
  id, 
  type = 'text', 
  placeholder, 
  value, 
  onChange, 
  required = false,
  error,
  className = '',
  autoComplete = 'on',
  ...props 
}) => {
  const inputClass = `form-input ${error ? 'form-input-error' : ''} ${className}`.trim();
  
  return (
    <div className="form-group">
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <input
        id={id}
        name={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={inputClass}
        autoComplete={autoComplete}
        {...props}
      />
      {error && <span className="form-error">{error}</span>}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  required: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
  autoComplete: PropTypes.string
};

export default Input;
